import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function HomeGrid() {
  return (
      <div className="d-flex m-5 justify-content-center align-items-center">
<iframe
allow="microphone;"
width="350"
height="430"
src="https://console.dialogflow.com/api-client/demo/embedded/30fbe8e1-8f43-4330-b9df-e1057fe9140c">
</iframe>
      </div> 

  );
}

export default HomeGrid;
